/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import LocalizedStrings from "react-localization";

let localizationJson = null;
let dashboardLocalization = null;
let loginLocalization = null;

export const getLocalizationJson = () => localizationJson;
export const getDashboardLocalization = () => dashboardLocalization;
export const getLoginLocalization = () => loginLocalization;

const dashboardLocale = (key) => dashboardLocalization[key];
export const dashboardLocaleFormat = (...keys) => dashboardLocalization.formatString(...keys);

export const loginLocale = (key) => loginLocalization[key];
export const loginLocaleFormat = (...keys) => loginLocalization.formatString(...keys);

export const initializeLocalization = async (onInitialized, onError) => {
  try {
    // fetch localization json
    const response = await fetch("localization/localization.json");
    localizationJson = await response.json();
    dashboardLocalization = new LocalizedStrings(localizationJson);
    loginLocalization = new LocalizedStrings(localizationJson);
    onInitialized();
  } catch (error) {
    onError(error);
  }
};

export const localizations = [
  // Supported
  { id: "en", name: "English", supported: true },
  { id: "es", name: "Español", supported: true },
  { id: "fr", name: "Français", supported: true },
  { id: "it", name: "Italiano", supported: true },
  { id: "pt", name: "Português", supported: true },
  { id: "ru", name: "Русский", supported: true },
  { id: "uk", name: "українська", supported: true },
  { id: "pl", name: "Polski", supported: true },
  { id: "lt", name: "Lietuvių", supported: true },
  { id: "cs", name: "čeština", supported: true },
  { id: "ro", name: "Română", supported: true },
  { id: "ar", name: "اَلْعَرَبِيَّةُ", supported: true },
  { id: "de", name: "Deutsch", supported: true },
  
  // Non Supported
  { id: "aa", name: "Afaraf", supported: false },
  { id: "ab", name: "аҧсуа бызшәа", supported: false },
  { id: "ae", name: "avesta", supported: false },
  { id: "af", name: "Afrikaans", supported: false },
  { id: "ak", name: "Akan", supported: false },
  { id: "am", name: "አማርኛ", supported: false },
  { id: "an", name: "aragonés", supported: false },
  { id: "as", name: "অসমীয়া", supported: false },
  { id: "av", name: "авар мацӀ", supported: false },
  { id: "ay", name: "aymar aru", supported: false },
  { id: "az", name: "azərbaycan dili", supported: false },
  { id: "ba", name: "башҡорт теле", supported: false },
  { id: "be", name: "беларуская мова", supported: false },
  { id: "bg", name: "български език", supported: false },
  { id: "bi", name: "Bislama", supported: false },
  { id: "bm", name: "bamanankan", supported: false },
  { id: "bn", name: "বাংলা", supported: false },
  { id: "bo", name: "བོད་ཡིག", supported: false },
  { id: "br", name: "brezhoneg", supported: false },
  { id: "bs", name: "bosanski jezik", supported: false },
  { id: "ca", name: "Català", supported: false },
  { id: "ce", name: "нохчийн мотт", supported: false },
  { id: "ch", name: "Chamoru", supported: false },
  { id: "co", name: "corsu", supported: false },
  { id: "cr", name: "ᓀᐦᐃᔭᐍᐏᐣ", supported: false },
  { id: "cu", name: "ѩзыкъ словѣньскъ", supported: false },
  { id: "cv", name: "чӑваш чӗлхи", supported: false },
  { id: "cy", name: "Cymraeg", supported: false },
  { id: "da", name: "dansk", supported: false },
  { id: "dv", name: "ދިވެހި", supported: false },
  { id: "dz", name: "རྫོང་ཁ", supported: false },
  { id: "ee", name: "Eʋegbe", supported: false },
  { id: "el", name: "Ελληνικά", supported: false },
  { id: "eo", name: "Esperanto", supported: false },
  { id: "et", name: "eesti", supported: false },
  { id: "eu", name: "euskara", supported: false },
  { id: "fa", name: "فارسی", supported: false },
  { id: "ff", name: "Fulfulde", supported: false },
  { id: "fi", name: "suomi", supported: false },
  { id: "fj", name: "vosa Vakaviti", supported: false },
  { id: "fo", name: "føroyskt", supported: false },
  { id: "fy", name: "Frysk", supported: false },
  { id: "ga", name: "Gaeilge", supported: false },
  { id: "gd", name: "Gàidhlig", supported: false },
  { id: "gl", name: "galego", supported: false },
  { id: "gn", name: "Avañe'ẽ", supported: false },
  { id: "gu", name: "ગુજરાતી", supported: false },
  { id: "gv", name: "Gaelg", supported: false },
  { id: "ha", name: "هَوُسَ", supported: false },
  { id: "he", name: "עברית", supported: false },
  { id: "hi", name: "हिन्दी", supported: false },
  { id: "ho", name: "Hiri Motu", supported: false },
  { id: "hr", name: "Hrvatski", supported: false },
  { id: "ht", name: "Kreyòl ayisyen", supported: false },
  { id: "hu", name: "magyar", supported: false },
  { id: "hy", name: "Հայերեն", supported: false },
  { id: "hz", name: "Otjiherero", supported: false },
  { id: "ia", name: "Interlingua", supported: false },
  { id: "id", name: "Bahasa Indonesia", supported: false },
  { id: "ie", name: "Interlingue", supported: false },
  { id: "ig", name: "Asụsụ Igbo", supported: false },
  { id: "ii", name: "ꆈꌠ꒿ Nuosuhxop", supported: false },
  { id: "ik", name: "Iñupiaq", supported: false },
  { id: "io", name: "Ido", supported: false },
  { id: "is", name: "Íslenska", supported: false },
  { id: "iu", name: "ᐃᓄᒃᑎᑐᑦ", supported: false },
  { id: "ja", name: "日本語", supported: false },
  { id: "jv", name: "basa Jawa", supported: false },
  { id: "ka", name: "ქართული", supported: false },
  { id: "kg", name: "Kikongo", supported: false },
  { id: "ki", name: "Gĩkũyũ", supported: false },
  { id: "kj", name: "Kuanyama", supported: false },
  { id: "kk", name: "қазақ тілі", supported: false },
  { id: "kl", name: "kalaallisut", supported: false },
  { id: "km", name: "ខេមរភាសា", supported: false },
  { id: "kn", name: "ಕನ್ನಡ", supported: false },
  { id: "ko", name: "한국어", supported: false },
  { id: "kr", name: "Kanuri", supported: false },
  { id: "ks", name: "कश्मीरी", supported: false },
  { id: "ku", name: "Kurdî", supported: false },
  { id: "kv", name: "коми кыв", supported: false },
  { id: "kw", name: "Kernewek", supported: false },
  { id: "ky", name: "Кыргызча", supported: false },
  { id: "la", name: "latine", supported: false },
  { id: "lb", name: "Lëtzebuergesch", supported: false },
  { id: "lg", name: "Luganda", supported: false },
  { id: "li", name: "Limburgs", supported: false },
  { id: "ln", name: "Lingála", supported: false },
  { id: "lo", name: "ພາສາລາວ", supported: false },
  { id: "lu", name: "Kiluba", supported: false },
  { id: "lv", name: "latviešu valoda", supported: false },
  { id: "mg", name: "fiteny malagasy", supported: false },
  { id: "mh", name: "Kajin M̧ajeļ", supported: false },
  { id: "mi", name: "te reo Māori", supported: false },
  { id: "mk", name: "македонски јазик", supported: false },
  { id: "ml", name: "മലയാളം", supported: false },
  { id: "mn", name: "Монгол хэл", supported: false },
  { id: "mr", name: "मराठी", supported: false },
  { id: "ms", name: "Bahasa Melayu", supported: false },
  { id: "mt", name: "Malti", supported: false },
  { id: "my", name: "ဗမာစာ", supported: false },
  { id: "na", name: "Dorerin Naoero", supported: false },
  { id: "nb", name: "Norsk bokmål", supported: false },
  { id: "nd", name: "isiNdebele", supported: false },
  { id: "ne", name: "नेपाली", supported: false },
  { id: "ng", name: "Owambo", supported: false },
  { id: "nl", name: "Nederlands", supported: false },
  { id: "nn", name: "Norsk nynorsk", supported: false },
  { id: "no", name: "Norsk", supported: false },
  { id: "nr", name: "isiNdebele", supported: false },
  { id: "nv", name: "Diné bizaad", supported: false },
  { id: "ny", name: "chiCheŵa", supported: false },
  { id: "oc", name: "occitan", supported: false },
  { id: "oj", name: "ᐊᓂᔑᓈᐯᒧᐎᓐ", supported: false },
  { id: "om", name: "Afaan Oromoo", supported: false },
  { id: "or", name: "ଓଡ଼ିଆ", supported: false },
  { id: "os", name: "ирон æвзаг", supported: false },
  { id: "pa", name: "ਪੰਜਾਬੀ", supported: false },
  { id: "pi", name: "पाऴि", supported: false },
  { id: "ps", name: "پښتو", supported: false },
  { id: "qu", name: "Runa Simi", supported: false },
  { id: "rm", name: "rumantsch grischun", supported: false },
  { id: "rn", name: "Ikirundi", supported: false },
  { id: "rw", name: "Ikinyarwanda", supported: false },
  { id: "sa", name: "संस्कृतम्", supported: false },
  { id: "sc", name: "sardu", supported: false },
  { id: "sd", name: "सिन्धी", supported: false },
  { id: "se", name: "Davvisámegiella", supported: false },
  { id: "sg", name: "yângâ tî sängö", supported: false },
  { id: "si", name: "සිංහල", supported: false },
  { id: "sk", name: "slovenčina", supported: false },
  { id: "sl", name: "slovenščina", supported: false },
  { id: "sm", name: "gagana fa'a Samoa", supported: false },
  { id: "sn", name: "chiShona", supported: false },
  { id: "so", name: "Soomaaliga", supported: false },
  { id: "sq", name: "Shqip", supported: false },
  { id: "sr", name: "српски језик", supported: false },
  { id: "ss", name: "SiSwati", supported: false },
  { id: "st", name: "Sesotho", supported: false },
  { id: "su", name: "Basa Sunda", supported: false },
  { id: "sv", name: "Svenska", supported: false },
  { id: "sw", name: "Kiswahili", supported: false },
  { id: "ta", name: "தமிழ்", supported: false },
  { id: "te", name: "తెలుగు", supported: false },
  { id: "tg", name: "тоҷикӣ", supported: false },
  { id: "th", name: "ไทย", supported: false },
  { id: "ti", name: "ትግርኛ", supported: false },
  { id: "tk", name: "Türkmençe", supported: false },
  { id: "tl", name: "Wikang Tagalog", supported: false },
  { id: "tn", name: "Setswana", supported: false },
  { id: "to", name: "faka Tonga", supported: false },
  { id: "tr", name: "Türkçe", supported: false },
  { id: "ts", name: "Xitsonga", supported: false },
  { id: "tt", name: "татар теле", supported: false },
  { id: "tw", name: "Twi", supported: false },
  { id: "ty", name: "Reo Tahiti", supported: false },
  { id: "ug", name: "ئۇيغۇرچە", supported: false },
  { id: "ur", name: "اردو", supported: false },
  { id: "uz", name: "Ўзбек", supported: false },
  { id: "ve", name: "Tshivenḓa", supported: false },
  { id: "vi", name: "Tiếng Việt", supported: false },
  { id: "vo", name: "Volapük", supported: false },
  { id: "wa", name: "walon", supported: false },
  { id: "wo", name: "Wollof", supported: false },
  { id: "xh", name: "isiXhosa", supported: false },
  { id: "yi", name: "ייִדיש", supported: false },
  { id: "yo", name: "Yorùbá", supported: false },
  { id: "za", name: "Saɯ cueŋƅ", supported: false },
  { id: "zh", name: "中文", supported: false },
  { id: "zu", name: "isiZulu", supported: false },
];

export const supportedLocalizations = localizations.filter(localization => localization.supported);

export const supportedLocalizationOptions = (showDefault = false) => (
  <>
    {showDefault && <option value="">Device Default</option>}
    {supportedLocalizations.map((localization, index) => (
      <option key={index} value={localization.id}>{localization.name}</option>
    ))}
  </>
);

export const validateLocale = (locale) => {
  if (locale) {
    // see if locale has subset specified
    const dashIndex = locale.indexOf("-");
    if (dashIndex !== -1) {
      locale = locale.slice(0, dashIndex);
    }

    // check if locale exists in constructor object
    if (localizationJson[locale] != null) {
      return locale;
    }
  }

  return null;
};

export const localeToString = (locale) => {
  const id = validateLocale(locale);
  return supportedLocalizations.find(item => item.id === id)?.name;
};

export default dashboardLocale;